import React, { useEffect, useState } from 'react'
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { GOOGLE_API_KEY } from '../../config'
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps'
import { getAlertMapDetails } from '../../services/chatFlowService'
import { LocationIcon, MapPinIcon } from '../../assets/images'
import Draggable from 'react-draggable'

const API_KEY = GOOGLE_API_KEY

let tempPos = {
    lat: 19.0747045, lng: 72.8869815   
    // lat: 19.2143377, lng: 73.1024171
}

const ChatflowMap = ( { alertId, deviceId, details }) => {

    const [centerPos, setCenterPos] = useState(tempPos)
    const [display, setDisplay] = useState(false)
    const [showGoogleMap, setShowGoogleMap] = useState(false)
    const [selectedImage, setSelectedImage] = useState(null);
    const [droppedItems, setDroppedItems] = useState([]);

    useEffect(() => {
        getMapDetails(deviceId);
    }, [deviceId])

    const getMapDetails = (id) => {
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        getAlertMapDetails(loggedInUser?.Id, id)
            .then((res) => {
                if(res.Status == "success"){
                    if(res.Data?.isGoogleMap){
                        let tempPos = {
                            lat: res.Data?.lat, 
                            lng: res.Data?.long   
                        }
                        setCenterPos(tempPos)
                        let obj = {
                            DeviceId: deviceId,
                            position: {
                                lat: res.Data?.latitude == '0.0' ? res.Data?.lat : res.Data?.latitude,
                                lng: res.Data?.longitude == '0.0' ? res.Data?.long : res.Data?.longitude
                            }
                        }
                        let data = [obj]
                        setDroppedItems(data);
                    }else{
                        let obj = {
                            DeviceId: deviceId,
                            position: {
                                x: res.Data?.latitude,
                                y: res.Data?.longitude
                            }
                        }
                        let data = [obj]
                        setDroppedItems(data);
                    }
                    setShowGoogleMap(res.Data.isGoogleMap);
                    if(res.Data?.imageUrl == ""){
                        setSelectedImage(null)
                    }else{
                        setSelectedImage(res.Data.imageUrl);
                    }
                    // setSelectedImage('https://incidentreportsbuckettest.s3.ap-south-1.amazonaws.com/1/AlertListView.png');
                }
            }).catch(err => console.log(err));
    }

    const openModal = (e) => {
        e.stopPropagation();
        setDisplay(true);
    }

    const closeModal = (e) => {
        setDisplay(false)
    }

  return (
    <>
        <div>
            {/* <button className="" onClick={(e) => openModal(e)} >Map</button> */}
            <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip style={{zIndex: 99999 }}>Map</Tooltip>}                
                >
                    <button
                    className="TwoWayAudioToggle two-way-and-hooter-on-off"
                    onClick={(e) => openModal(e)}
                    >
                        <img
                          style={{ padding: "2px", color: 'white' }}
                        //   src={MosaicHooterOff}
                            src={LocationIcon}
                          alt="location icon"
                        />
                    </button>
                </OverlayTrigger>
        </div>
        <div style={{zIndex:'99999'}} onClick={(e) => e.stopPropagation()} >
            <Modal style={{ zIndex: "99999" }} show={display} size='xl' dialogClassName="healthMonitorModel" onHide={() => setDisplay(false)}>
                <Modal.Header closeButton onHide={(e) => closeModal(e)}>
                    <Modal.Title>
                        <p>Alert Id - {alertId}</p>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                <div style={{
                    display: 'flex',
                    gap: '2rem',
                    justifyContent: 'center',
                    marginBottom: '1rem'
                }}>
                        <div className="PanelDetailDiv">
                                    <p>
                                      Site Name{" "}
                                      <span>
                                        {" "}
                                        - {details?.site}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="PanelDetailDiv">
                                    <p>
                                      Device Name{" "}
                                      <span>
                                        {" "}
                                        - {details?.deviceName}
                                      </span>
                                    </p>
                                  </div>
                        </div>
                    <div className='m-auto MapContainerFlex mapDiv' 
                    style={{height: '600px', width: '1150px', justifyContent: 'center' }}
                    >
                        {
                            showGoogleMap
                            ?
                            <div className='Map_Preview'>
                            {/* <p className='Map_Preview_text'>Map Preview</p> */}
                            
                            <APIProvider apiKey={API_KEY}>
                                <div
                                    style={{ padding: '0.5rem', width: '100%', height: '100%', position: 'relative' }}
                                    // onDrop={handleMapDrop}
                                    // onDragOver={handleDragOver}
                                >
                                    <Map
                                        style={{ width: '100%', height: '100%' }}
                                        //center={centerPos}
                                        defaultCenter={centerPos}
                                        // defaultCenter={{ lat: 19.0747045, lng: 72.8869815 }}
                                        defaultZoom={15}
                                        reuseMaps={true}
                                        gestureHandling={'greedy'}
                                        scrollwheel={true}
                                        // zoomControl={editForm}
                                        // streetViewControl={editForm}
                                        // fullscreenControl={editForm}
                                        // disableDoubleClickZoom={!editForm}
                                        // scrollwheel={editForm}
                                        // draggableCursor={editForm}
            
                                    // disableDefaultUI={true}
                                    >
                                        {
                                            droppedItems?.map((item) => (
                                                <Marker
                                                    key={item.DeviceId}
                                                    position={item.position}
                                                    // onClick={() => setSelectedMarker(item)}
                                                    draggable={false}
                                                    // clickable={editForm}
                                                    // onDragEnd={(e) => handleMarkerDragEnd(e, item.DeviceId)}
                                                    // icon={{
                                                    //     url: MapPinIcon,
                                                    //     scaledSize: new window.google.maps.Size(50, 50),
                                                    // }}
                                                />
                                            ))
                                        }
                                        {/* {markerList?.map((item) => (
                                            <Marker
                                                key={item.DeviceId}
                                                position={item.position}
                                                onClick={() => setSelectedMarker(item)}
                                                draggable={editForm}
                                                // clickable={editForm}
                                                onDragEnd={(e) => handleMarkerDragEnd(e, item.DeviceId)}
                                                icon={{
                                                    url: MapPinIcon,
                                                    scaledSize: new window.google.maps.Size(50, 50),
                                                }}
                                            />
                                        ))} */}
                                        {/* {selectedMarker && (
                                            <InfoWindow
                                                position={selectedMarker.position}
                                                onCloseClick={() => setSelectedMarker(null)}
                                            >
                                                <div>
                                                    <h4>{selectedMarker.Name}</h4>
                                                    <p>Latitude: {selectedMarker.position.lat}</p>
                                                    <p>Longitude: {selectedMarker.position.lng}</p>
                                                </div>
                                            </InfoWindow>
                                        )} */}
            
                                    </Map>
                                </div>
                            </APIProvider>
                            
                        </div>

                            :
                            <div className='Map_Preview'>
                                <div className='Image_Container' 
                                style={{ height: '424px',width: '870px',margin: '1.5rem', position: 'relative', overflow: 'hidden' }}>
                                <img
                                src={selectedImage}
                                alt="Drop zone"
                                style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
                                />      
                                          {droppedItems.map((item, index) => (
                                              <Draggable
                                                  disabled={true}
                                                  key={item.DeviceId}
                                                  position={item.position}
                                                  // onStop={(e, data) => handleDrag(index, e, data, item)}
                                                //   onDrag={(e, data) => handleDrag(index, e, data, item)}
                                                  bounds="parent"
                                              >

                                                  <div
                                                      style={{
                                                          position: 'absolute',
                                                          fontSize: '5px',
                                                          cursor: 'not-allowed',
                                                          width: '40px',
                                                          height: '40px',
                                                          backgroundImage: `url(${MapPinIcon})`,
                                                          backgroundSize: 'cover',
                                                          backgroundPosition: 'center'
                                                      }}
                                                      title={item.Name}
                                                  >
                                                  </div>
                                              </Draggable>
                                          ))}
                                </div>
                            </div>
                        }
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    </>
  )
}

export default ChatflowMap